/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesRiskClasses.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Risk Class Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, January 21, 2019 - 04:45:03 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      01/21/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const RiskClassList = Loadable({
    loader: () => import('../containers/RiskClasses/RiskClassListContainer'),
    loading: Loading,
});

export const RiskClassForm = Loadable({
    loader: () => import('../containers/RiskClasses/RiskClassEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesRiskClasses.js